import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PostCard from '../../components/PostCard/PostCard';

export default function PostDetail({ posts = [], loggedInUser, markPostRead }) {
  const { id } = useParams();
  const post = posts.find((p) => p.id === id);

  useEffect(() => {
    if (post && loggedInUser && typeof markPostRead === 'function') {
      markPostRead(post.id, loggedInUser.id);
    }
  }, [post, loggedInUser, markPostRead]);

  if (!post) return <div style={{ padding: 24 }}>未找到文章。</div>;
  return (
    <div className="page-container">
      <PostCard post={post} />
      {/* show full content below preview */}
      <div style={{ marginTop: 16 }}>
        <div style={{ whiteSpace: 'pre-wrap' }}>{post.content}</div>
      </div>
    </div>
  );
}
